import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Modal } from "antd";
import "./Login.scss";
import LoginForm from "./LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { NavLink } from "react-router-dom";
import CompanyLogo from  '../../assets/images/expo_logo.png';

export default function Login() {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  sessionStorage.setItem("loginPage", "true");

console.log('console added for testing')
  useEffect(() => {
    if (isMobile) {
      setIsMobileView(true);
    }
  });

  return (
    <div className="login-bg">
      {/* {isMobile ? (
        // toast.error("Better viwed on larger screens")
        toast.info('Better viewed on larger screens!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      ) : ""} */}
      <div className="login-main-container">
        <div className="login-left-panel">
          {/* <p>hello</p> */}
          <img 
            src={CompanyLogo} 
            alt="company logo" 
            className="company-logo"
          />
        </div>
        <div className="login-right-panel">
            <div className="partner-portal">Partner Portal</div>

          <div className="card">
            {/* <div className="logo">
              <img
                src={require("../../assets/images/connectuslogo.png")}
                alt="company logo"
              />
            </div> */}
            {isLoginMode ? (
              <LoginForm />
            ) : (
              <ForgotPasswordForm setIsLoginMode={setIsLoginMode} />
            )}
            <div className="links">
              {/* <NavLink to="/signup" className="sign-up">
                Sign up
              </NavLink> */}
              <NavLink to="/forgot-password" className="forgot-password">
                Forgot Password
              </NavLink>

              {/* 
              <p
                className="forgot-password"
                onClick={() => setIsLoginMode(!isLoginMode)}
              >
                {isLoginMode ? "Forgot Password?" : "Cancel"}
              </p> */}
            </div>
            <div className="footer d-flex">
              <div
                className="footer-content"
                onClick={() =>
                  window.open("https://www.connectsu.co.uk/", "_blank")
                }
                style={{ cursor: "pointer" }}
              >
                {/* <span>Powered by</span> */}
                <div className="footer-logo">
                  <img
                    src={require("../../assets/images/PoweredNew.png")}
                    alt="company logo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        // width={250}
        // style={{ top: "30vh", right: "-73vh" }}
        open={isMobileView}
        onCancel={() => setIsMobileView(false)}
        footer={null}
        closable={false}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p>
            <b>Better viewed on a laptop or a desktop</b>
          </p>
        </div>
      </Modal>
    </div>
  );
}
